import { SiteId } from '../../../../contexts/MenuContext/mapping.mjs';
import { partsToPathname } from '../../../../utils/url.mjs';
"use strict";
const getStorePathParts = (storePathParts, storeId) => {
  if (typeof storePathParts === "function") {
    return storePathParts(storeId);
  }
  return storePathParts;
};
const getStoreHref = ({
  product,
  createSiteUrl,
  storeId
}) => {
  const storePathParts = getStorePathParts(product.storePathParts, storeId);
  if (!storePathParts) {
    return void 0;
  }
  const pathParts = [];
  if (storePathParts?.category) {
    pathParts.push("category", storePathParts?.category);
  }
  if (storePathParts?.collectionSlug) {
    pathParts.push("collections", storePathParts?.collectionSlug);
  }
  if (storePathParts?.productSlug) {
    pathParts.push("products", storePathParts?.productSlug);
  }
  const storePathString = partsToPathname(pathParts);
  return createSiteUrl([SiteId.Store, storePathString, storePathParts?.variant ? {
    variant: storePathParts.variant
  } : void 0]);
};
export { getStoreHref };
//# sourceMappingURL=getStoreHref.mjs.map
